__turbopack_context__.v({
  "actif": "NavMembre-module__4F935W__actif",
  "nav": "NavMembre-module__4F935W__nav",
  "onglet": "NavMembre-module__4F935W__onglet",
});
